import React from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import Styled from "components/finance/style";

bootstrapUtils.addStyle(Button, "grey");

function RaiseCapitalButton(props) {
  const { onClick, loading } = props;

  const style = loading === true ? "grey" : "primary";

  return (
    <Styled.UIButton
      className="btn-fn-decisions-button"
      bsStyle={style}
      onClick={onClick}
      disabled={loading}
    >
      {loading === true ? "Loading..." : "Raise Capital"}
    </Styled.UIButton>
  );
}

export default RaiseCapitalButton;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/raise-capital-button.js